import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postGenerateProjectEmployeeReport = async (
  projectId,
  generationParams
) => {
  const apiPath = `report/${projectId}/project-employee-report`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: { generationParams },
    isLocalApiRequest: false,
  });

  const response = await axios(signedRequest);

  return response.data;
};
